import { ListPropertyOptions } from '../../interfaces/options';
import { PropertyType } from '../../enums';

export const DefaultListPropertyOptions: ListPropertyOptions = {
	css: '',
	isEditable: false,
	isFilterable: true,
	isSortable: true,
	key: null,
	type: PropertyType.STRING,
	rules: []
};
